export default __webpack_public_path__ + "static/drawing-002422d87689756f5b5cdc0c1b48355a.png";